import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import Loaders from "../Loaders";
import BreadcrumTop from "../BreadcrumTop";
import { getToken } from "../../../utils/getToken";
import { API_ROUTES } from "../../../utils/constants";

export default function MarketerDetails(props) {
  const { isLoaded } = props;

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pid, setPid] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.rowData;
  // console.log("company data", rowData);
  useEffect(() => {
    if (rowData) {
      //   console.log("company id", rowData.companyId);
      setId(rowData.id || "Not Available");
      setName(rowData.name || "Not Available");
      setEmail(rowData.email || "Not Available");
      setPid(rowData.pId || "Not Available");
      setUnitPrice(rowData.unitPrice || "Not Available");
      setCompanyId(rowData.companyId || "Not Available");
      setUrl(rowData.url || "Not Available");
    }
  }, [rowData]);

  return (
    <>
      {/* <Loaders isLoaded={isLoaded} /> */}

      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body">
          <div className="container-fluid">
            <BreadcrumTop title=" Marketer Details" />

            <div className="row">
              <div className="col-xl-7 col-lg-10 col-md-10 mx-auto">
                <div className="card">
                  <div className="card-body">
                    <div className="basic-form">
                      <div className="d-flex justify-content-end">
                        <Link
                          to="/marketers"
                          state={{ rowData: { id: companyId } }}
                          className="btn btn-dark m-1"
                        >
                          Go Back
                        </Link>
                      </div>
                      <ol className="list-group  my-5">
                        <li className="list-group-item d-flex justify-content-between align-items-start">
                          <div className="ms-2 me-auto">
                            <div className="fw-bold text-uppercase fs-5">
                              Company name
                            </div>
                          </div>
                          <span className="badge text-bg-primary  text-white fs-4 ">
                            {name}
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-start">
                          <div className="ms-2 me-auto">
                            <div className="fw-bold text-uppercase fs-5">
                              Email
                            </div>
                          </div>
                          <span className="badge text-bg-primary  text-white fs-4 ">
                            {email}
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-start">
                          <div className="ms-2 me-auto">
                            <div className="fw-bold text-uppercase fs-5">
                              Url
                            </div>
                          </div>
                          <span className="badge text-bg-primary  text-white fs-4 ">
                            {url}
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-start">
                          <div className="ms-2 me-auto">
                            <div className="fw-bold text-uppercase fs-5">
                              pId
                            </div>
                          </div>
                          <span className="badge text-bg-primary  text-white fs-4 ">
                            {pid}
                          </span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between align-items-start">
                          <div className="ms-2 me-auto">
                            <div className="fw-bold text-uppercase fs-5">
                              Unit Price
                            </div>
                          </div>
                          <span className="badge text-bg-primary  text-white fs-4 ">
                            {unitPrice}
                          </span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
